import * as React from "react";
import moment from "moment";
export interface IRenderSuggestionProps {
    highlightedIndex: number;
    index: number;
    itemProps: any;
    suggestion: string;
}

export const getFilteredSuggestions = (value: string, suggestionsToFilter: string[], { showEmpty = false } = {}) => {
    const trimedInputValue = value ? value.trim().toLowerCase() : "";
    const filteredArray = suggestionsToFilter
        ? suggestionsToFilter.filter((suggestion) => {
              const trimedLowerSuggestion = suggestion?.trim().toLowerCase() ?? "";
              return trimedLowerSuggestion.includes(trimedInputValue);
          })
        : [];
    if (trimedInputValue.length === 0 && !showEmpty && suggestionsToFilter) {
        return suggestionsToFilter;
    } else {
        return filteredArray;
    }
};

export const markupGenerator = (inputValue, suggestion) => {
    let returnSuggestion = <span>{suggestion}</span>;
    if (inputValue && inputValue.length > 0) {
        const startIndex = suggestion.toLowerCase().indexOf(inputValue.toLowerCase());
        if (startIndex !== -1 && inputValue.length > 0) {
            returnSuggestion = (
                <span>
                    {suggestion.slice(0, startIndex)}
                    <b>{suggestion.slice(startIndex, startIndex + inputValue.length)}</b>
                    {suggestion.slice(startIndex + inputValue.length)}
                </span>
            );
        }
    }
    return returnSuggestion;
};

export interface IDate {
    year: number;
    month: number;
    day: number;
}

export const validDateFormatArray = ["MM/DD/YYYY", "M/D/YY", "M/D/YYYY"];
export const isValidDateFormat = (dateString: string, validDateFormat: string[], strictMode?: boolean) => {
    const formatArray = !!validDateFormat[0] && validDateFormat.length ? validDateFormat : validDateFormatArray;

    if (!!dateString && moment(dateString, formatArray, strictMode).isValid()) {
        const momentDate = moment.utc(dateString, formatArray);
        // NOTE: for non-strict mode, if user input 1/2/3, the momentDate.year() will be 3, which is not valid for input.
        // the year value must be 2 or 4 digits. e.g. 1/2/10 yaer value will be auto-completed as 2010, or 1/2/2010.
        return momentDate.year().toString().length >= 4;
    }
    return false;
};
